export default {
  body: {
    heading: {
      partOne: 'The average retail trade grosses a',
      partTwo: 'dealership between $4700 - $7200 per unit.',
    },
    subHeading: 'What is a retail trade worth to your dealership?',
    quesOne: 'Need used inventory?',
    quesTwo:
      'Tired of trying to hire the right people for inventory acquisition?',
    quesThree:
      'Tired of not taking advantage of potential inventory coming through your service lane?',
    lastLine: {
      partOne: 'If you said',
      partTwo: 'yes',
      partThree: 'to any one of these, click here',
    },
  },
  buttons: {
      home: 'Home',
      howItWorks: 'How It Works',
      login: 'Login',
    contactUs: 'Contact Us',
  },
};
